import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import qs from 'qs';
import config from '../config';
import { requestInterceptor, responseFulfilledInterceptor, responseInterceptor } from '../utils/login';
var instance = axios.create({
  baseURL: '',
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json' // application/x-www-form-urlencoded
  },

  withCredentials: true,
  paramsSerializer: function paramsSerializer(params) {
    return qs.stringify(params, {
      arrayFormat: 'repeat'
    });
  }
});
var CancelToken = axios.CancelToken;
// eslint-disable-next-line no-restricted-globals
var isVenv = function isVenv() {
  return location.host.includes('-venv.');
};
instance.interceptors.request.use(requestInterceptor({
  setConfig: function setConfig(c) {
    var _c$baseURL;
    if (!((_c$baseURL = c.baseURL) === null || _c$baseURL === void 0 ? void 0 : _c$baseURL.startsWith('http')) && process.env.REACT_APP_ENV !== 'development' && !isVenv()) {
      c.baseURL = config.HTTP_BASE_URL + c.baseURL;
    }
    return c;
  }
}), function (err) {
  return Promise.reject(err);
});
instance.interceptors.response.use(responseFulfilledInterceptor(), responseInterceptor());
export function request(req) {
  var source = CancelToken.source();
  return instance.request(_objectSpread(_objectSpread({}, req), {}, {
    cancelToken: source.token,
    // @ts-ignore
    cancelTokenSource: source
  }));
}